export const getHelloNextLoginServiceUrl = (): string => {
  const [, ...domainParts] = window.location.hostname.split('.')
  const domain = domainParts.join('.')

  return `https://callbacks.${domain}/hellonext?domain=buffer`
}
